import { Component, OnInit } from '@angular/core';
import { ModalController, AlertController } from '@ionic/angular';
import { Scene } from 'src/app/models/Scene';
import { Outcome } from 'src/app/models/outcomes/Outcome';
import { OutcomeAction } from 'src/app/models/outcomes/OutcomeAction';
import { OutcomeActionTypeService } from 'src/app/services/outcome-action-type.service';
import { UnfocusElementService } from 'src/app/services/unfocus-element.service';
import { OutcomeActionService } from 'src/app/services/outcome-action.service';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { MessagesService } from 'src/app/services/messages.service';

@Component({
  selector: 'app-add-outcome-action-modal',
  templateUrl: './add-outcome-action-modal.page.html',
  styleUrls: ['./add-outcome-action-modal.page.scss'],
})
export class AddOutcomeActionModalPage implements OnInit {
  public asset: AssetInScene;
  public scene: Scene;
  public projectOutcomes: Outcome[];
  public outcomeActions: OutcomeAction[];
  public outcomeAction = {} as OutcomeAction;
  public projectId: number;
  public addedOutcomeActions : OutcomeAction[];

  constructor(
    public modalController: ModalController,
    public outcomeActionTypeService: OutcomeActionTypeService,
    public unfocusService: UnfocusElementService,
    public outcomeActionService: OutcomeActionService,
    public alertController: AlertController,
    public messageService: MessagesService
  ) { }

  ngOnInit() {
  }

  cancelModal() {
    this.modalController.dismiss();
  }

  addOutcomeActionToDb(){
    this.messageService.presentLoadingWindow("Adding Outcome Action...");
      this.outcomeActionService.addOutcomesAction(this.outcomeAction).then(
        x=>{
          this.messageService.loadingWindow.dismiss();
          this.modalController.dismiss(this.outcomeAction);
        }
      );
  }

  getOutcomeGroup(outcomeId){
    return this.projectOutcomes.filter(x=>x.outcomeId == outcomeId)[0].title;
  }

  async addOutcomeAction(event) {
    this.unfocusService.unfocus(event);
    let displayOutcomeActionMissing = false;
    let displayOutcomeMissing = false;
    
    if(!this.outcomeAction.outcomeActionTypeId){
      displayOutcomeActionMissing = true;
    }
    if(!this.outcomeAction.outcome){
      displayOutcomeMissing = true;
    }

    if(displayOutcomeActionMissing == false && displayOutcomeMissing == false){
      this.outcomeAction.projectId = this.projectId;
      this.outcomeAction.outcomeId = this.outcomeAction.outcome.outcomeId;
      this.outcomeAction.outcomeGroupId = this.outcomeAction.outcome.outcomeGroupId;
      if(this.scene){
        this.outcomeAction.sceneId = this.scene.sceneId;
      }
      else{
        this.outcomeAction.sceneAssetRelationId = this.asset.sceneAssetRelation.sceneAssetRelationId;
      }

      if(this.addedOutcomeActions.length !=0){
        var existingActions = this.addedOutcomeActions.filter(x=>x.outcomeActionTypeId == this.outcomeAction.outcomeActionTypeId && x.outcomeId == this.outcomeAction.outcomeId);
        if(existingActions.length !=0){
          const alert = await this.alertController.create({
            header: 'Outcome Action Already Added',
            message: "This outcome action has already been added with this outcome. Please select a different outcome or a different outcome action.",
            cssClass: 'leave-alert',
            buttons: [{
              text: 'OK',
              cssClass: 'leave-button',
              handler: () => {
              }
            }]
          });
          await alert.present();
        }
        else{
          this.addOutcomeActionToDb();
        }
      }
      else{
        this.addOutcomeActionToDb();
      }
      
    }
    else{
      var message = "";
      if(displayOutcomeMissing){
        message += "Please select an outcome to add the outcome action to. ";
      }

      if(displayOutcomeActionMissing){
        message += "Please select an outcome action.";
      }
      const alert = await this.alertController.create({
        header: 'Missing Fields',
        message: message,
        cssClass: 'leave-alert',
        buttons: [{
          text: 'OK',
          cssClass: 'leave-button',
          handler: () => {
          }
        }]
      });
      await alert.present();
    }
    
  }

}
